"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getForbiddenCountryMccList = exports.registerTimeHorizonCreator = exports.getAccountCountryList = exports.getCountryInfoByAlpha2 = exports.getCountryInfo = exports.getKYCCountryList = exports.getCountryList = exports.getCountryListFromScene = exports.ModuleScene = exports.PlatFormForCountyType = void 0;
const trade_utils_lib_1 = require("trade_utils_lib");
const country_code_dict_1 = require("./KYCData/country_code_dict");
const country_info_dict_1 = require("./KYCData/country_info_dict");
const PionexLiteSupportCodeList_1 = require("./KYCData/PionexLiteSupportCodeList");
const PionexSupportCodeList_1 = require("./KYCData/PionexSupportCodeList");
var PlatFormForCountyType;
(function (PlatFormForCountyType) {
    PlatFormForCountyType["pionex"] = "pionex";
    PlatFormForCountyType["pionex_lite"] = "pionex_lite";
})(PlatFormForCountyType || (exports.PlatFormForCountyType = PlatFormForCountyType = {}));
var ModuleScene;
(function (ModuleScene) {
    /** 支持注册的 */
    ModuleScene["compliance"] = "compliance";
    ModuleScene["all"] = "all";
})(ModuleScene || (exports.ModuleScene = ModuleScene = {}));
/**
 * 登录限制手机号的国家
 */
const sign_in_limit_regions = ["PRK", "IRN", "SYR"];
function getLimitAreaCodes() {
    return (0, trade_utils_lib_1.getTradeDependencyInstance)().remoteConfig().getJson("sign_up_limit_regions") || [];
}
function getCountryListFromScene(scene) {
    const productType = (0, trade_utils_lib_1.getTradeDependencyInstance)().getProductType();
    if (trade_utils_lib_1.PRODUCT_TYPE.PIONEX_US === productType || trade_utils_lib_1.PRODUCT_TYPE.PIONEX_US_V2 === productType) {
        return countryCodesMapToInfo(new Set(["USA"]));
    }
    switch (scene) {
        case ModuleScene.compliance:
            return country_info_dict_1.CountryArray.filter((item) => { var _a, _b; return !((_b = (_a = getLimitAreaCodes()).includes) === null || _b === void 0 ? void 0 : _b.call(_a, item.codeAlpha3)); });
        case ModuleScene.all:
            return country_info_dict_1.CountryArray.filter((item) => !sign_in_limit_regions.includes(item.codeAlpha3));
        default:
            return [...country_info_dict_1.CountryArray];
    }
}
exports.getCountryListFromScene = getCountryListFromScene;
const countryCodesMapToInfo = (codes) => {
    const list = [];
    codes.forEach((e) => {
        const value = country_info_dict_1.CountryJSON[e];
        if (value && value.phoneAreaCode) {
            const splits = value.phoneAreaCode.split(",");
            if (splits.length > 1) {
                splits.forEach((areaCode) => {
                    const temp = Object.assign({}, value);
                    temp.phoneAreaCode = areaCode;
                    list.push(temp);
                });
            }
            else {
                list.push(value);
            }
        }
    });
    return list;
};
/**
 *
 * @param value
 * @deprecated
 */
function getCountryList(value) {
    let list1 = [];
    let list2 = [];
    if (value === PlatFormForCountyType.pionex) {
        list1 = countryCodesMapToInfo(new Set(PionexSupportCodeList_1.PionexSupportAreaList));
        list2 = countryCodesMapToInfo(new Set(PionexSupportCodeList_1.PionexSupportCountryCodeList));
    }
    else if (value === PlatFormForCountyType.pionex_lite) {
        list1 = countryCodesMapToInfo(new Set(PionexLiteSupportCodeList_1.PionexLiteSupportAreaCodeList1));
        list2 = countryCodesMapToInfo(new Set(PionexLiteSupportCodeList_1.PionexLiteSupportAreaCodeList2));
    }
    return list1.concat(list2.sort((a, b) => {
        return a.name.localeCompare(b.name);
    }));
}
exports.getCountryList = getCountryList;
/*KYC选择国家地区列表*/
function getKYCCountryList(sortByLocal) {
    const list = countryCodesMapToInfo(new Set(PionexSupportCodeList_1.PionexSupportAreaList));
    if (!sortByLocal) {
        return list;
    }
    function sort(a, b) {
        if (sortByLocal === "zh-CN") {
            return a.cname.localeCompare(b.cname);
        }
        else if (sortByLocal === "zh-TW") {
            return a.twName.localeCompare(b.twName);
        }
        else {
            return a.name.localeCompare(b.name);
        }
    }
    return list.sort(sort);
}
exports.getKYCCountryList = getKYCCountryList;
/**
 *
 * @param countryCode alpha3 编码格式
 * @param ipCode 通过查询IP得到的国家代码为alpha2 编码格式，需要做一个alpha2 => alpha3de
 * @return CountryInfo|undefined 多个区号国家返回第一个区号对应的国家信息
 */
function getCountryInfo(countryCode, ipCode) {
    let country_code = countryCode;
    if (ipCode) {
        country_code = country_code_dict_1.CountryCodeDict[countryCode];
    }
    const value = country_info_dict_1.CountryJSON[country_code];
    if (value) {
        const phoneAreaCode = value["phoneAreaCode"];
        if (phoneAreaCode) {
            const splits = phoneAreaCode.split(",");
            if (splits.length > 1) {
                const firstAreaValue = Object.assign({}, value);
                firstAreaValue.phoneAreaCode = splits[0];
                return firstAreaValue;
            }
        }
    }
    return value;
}
exports.getCountryInfo = getCountryInfo;
/**
 *
 * @param countryCode alpha2 编码格式
 * @return CountryInfo|undefined 根据alpha2 编码获取国家信息
 */
function getCountryInfoByAlpha2(countryCode) {
    const country_code = country_code_dict_1.CountryCodeDict[countryCode];
    return country_info_dict_1.CountryJSON[country_code];
}
exports.getCountryInfoByAlpha2 = getCountryInfoByAlpha2;
function sortFunc(a, b) {
    return a.phoneAreaCode.localeCompare(b.phoneAreaCode);
}
/**
 * 选择国家地区列表
 * @deprecated Use {@link getCountryListFromScene} instead
 * @param isSupportSpecial 是否支持特别国家
 * @param loginCorrelation 登录相关
 * @param deleteCodeArray  可剔除的国家
 */
function getAccountCountryList(isSupportSpecial, loginCorrelation, deleteCodeArray) {
    let countryList = [];
    if (loginCorrelation) {
        countryList = countryList.concat(PionexSupportCodeList_1.PionexSupportSignCodeList);
        if (isSupportSpecial) {
            countryList = countryList.concat(PionexSupportCodeList_1.PionexSupportCountryCodeList);
        }
    }
    else {
        countryList = countryList.concat(PionexSupportCodeList_1.PionexSupportAreaList);
        if (isSupportSpecial) {
            countryList = countryList.concat(PionexSupportCodeList_1.PionexSupportCountryCodeList);
        }
    }
    if (deleteCodeArray && deleteCodeArray.length > 0) {
        countryList = countryList.filter((item) => {
            return !deleteCodeArray.includes(item);
        });
    }
    const countrySetData = new Set(countryList);
    const list = countryCodesMapToInfo(countrySetData);
    return list.sort(sortFunc);
}
exports.getAccountCountryList = getAccountCountryList;
function registerTimeHorizonCreator() {
    const QUARTER_1 = ["01-01T00:00:00", "03-31T23:59:59"];
    const QUARTER_2 = ["04-01T00:00:00", "06-30T23:59:59"];
    const QUARTER_3 = ["07-01T00:00:00", "09-30T23:59:59"];
    const QUARTER_4 = ["10-01T00:00:00", "12-31T23:59:59"];
    const INIT_QUARTERS_ARR = [QUARTER_1, QUARTER_2, QUARTER_3, QUARTER_4, QUARTER_1, QUARTER_2, QUARTER_3, QUARTER_4];
    const nowMonth = new Date().getMonth();
    const spliceValue = nowMonth < 3 ? 1 : nowMonth < 6 ? 2 : nowMonth < 9 ? 3 : nowMonth < 12 ? 4 : 0;
    const shiftArr = INIT_QUARTERS_ARR.splice(0, spliceValue);
    const unShiftArr = INIT_QUARTERS_ARR;
    const result = [...unShiftArr, ...shiftArr]
        .reverse()
        .map((item, index) => {
        let nowYear = new Date().getFullYear();
        if (spliceValue - index <= 0) {
            nowYear -= spliceValue - index <= -4 ? 2 : 1;
        }
        return [new Date(`${nowYear}-${item[0]}`).getTime() / 1000, new Date(`${nowYear}-${item[1]}`).getTime() / 1000];
    })
        .reverse();
    result[0][0] = 0;
    return result;
}
exports.registerTimeHorizonCreator = registerTimeHorizonCreator;
/**
 * 获取不支持手机号绑定地区的MCC列表
 * @return MCC列表 string[]
 */
function getForbiddenCountryMccList() {
    const mccList = [];
    const countrySets = new Set(getLimitAreaCodes());
    countrySets.forEach((codeAlpha3) => {
        const _value = country_info_dict_1.CountryJSON[codeAlpha3];
        if (_value && _value.mcc) {
            const splits = _value.mcc.split("|");
            splits.forEach((mcc) => {
                mccList.push(mcc);
            });
        }
    });
    return mccList;
}
exports.getForbiddenCountryMccList = getForbiddenCountryMccList;
